// 自動掛載：在頁面找出兩種嵌入來源、為每個放上一個 <pulse-survey>。只由 IIFE 進入點
// (embed.ts) 呼叫 —— 絕不從 admin 會 import 的 package 進入點跑。idempotent：用 WeakSet 記下
// 處理過的節點，讓重掃（或 bundle 被載入兩次）變成 no-op。(spec §5.2)
//
// 廣告投放模型：帶 data-brand-id（+ data-category-id），後端依 brand+category 選題。
const processed = new WeakSet<Element>()

function setIf(el: HTMLElement, name: string, value: string | undefined): void {
  if (value)
    el.setAttribute(name, value)
}

// 由嵌入節點的 dataset 建一個 <pulse-survey>。brand-id 存在（呼叫端已確保）才會走到這裡。
// 自動掛載一律 lazy（捲到接近才載）。
function makeWidget(ds: DOMStringMap): HTMLElement {
  const el = document.createElement('pulse-survey')
  setIf(el, 'brand-id', ds.brandId)
  setIf(el, 'category-id', ds.categoryId)
  setIf(el, 'mpid', ds.mpid)
  el.setAttribute('layout', ds.layout === 'sidebar' ? 'sidebar' : 'inline')
  el.setAttribute('lazy', '')
  return el
}

export function autoMount(root: ParentNode = document): void {
  // (a) script[data-brand-id] —— 就地插在 script 之後（相容 async；不靠 currentScript）
  for (const script of root.querySelectorAll<HTMLScriptElement>('script[data-brand-id]')) {
    if (processed.has(script))
      continue
    processed.add(script) // 先標記：即使無 brand-id、後續重掃也永久跳過此 script
    const ds = script.dataset
    if (!ds.brandId)
      continue
    // 同一頁載入兩份 IIFE 時各有獨立 WeakSet —— 靠 sibling 檢查避免在同一個 script 後重複插入。
    if (script.nextElementSibling?.tagName.toLowerCase() === 'pulse-survey')
      continue
    script.insertAdjacentElement('afterend', makeWidget(ds))
  }

  // (b) [data-survey-zone] —— append 進 zone，除非 zone 內已有顯式元件
  for (const zone of root.querySelectorAll<HTMLElement>('[data-survey-zone]')) {
    if (processed.has(zone))
      continue
    if (zone.querySelector('pulse-survey')) {
      processed.add(zone) // 顯式子元件優先，永不雙掛
      continue
    }
    const ds = zone.dataset
    if (!ds.brandId)
      continue // 裝飾性 / 空 zone（無 brand-id）—— 不動
    processed.add(zone)
    zone.appendChild(makeWidget(ds))
  }

  // (c) 顯式 <pulse-survey> —— 完全不碰；元件被 define 後自行 upgrade
}
